import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import { useIsFeatureEnabled } from '@/stores/settingsStore';

// Opens the equation builder on a copy of this module. Shown to anyone the
// backend returns the definition to, not just the creator, and only in the
// pathway builder: the analyst workspace has no pathway to open it over.
const DuplicateEquationModuleButton = ({ customModel }) => {
  const { projectId, pathwayId, caseId } = useParams();
  const isEquationBuilderEnabled = useIsFeatureEnabled('equation_builder');

  if (!isEquationBuilderEnabled || customModel?.model_type !== 'equation' || !customModel.data) return null;
  if (!projectId || !pathwayId || !caseId) return null;

  return (
    <Link
      to={`/projects/${projectId}/build/pathways/${pathwayId}/${caseId}/choose-model/duplicate-equation-model/${customModel.id}`}
      className="btn btn-sm btn-ghost gap-2"
    >
      <DocumentDuplicateIcon className="h-5 w-5" />
      Duplicate
    </Link>
  );
};

DuplicateEquationModuleButton.propTypes = {
  customModel: PropTypes.shape({
    model_type: PropTypes.string,
    id: PropTypes.string,
    data: PropTypes.object,
  }),
};

export default DuplicateEquationModuleButton;
